export default "/project/@id";
